import React from 'react';
import styles from './styles.module.scss';
import { TextArea } from '@components-clean/core/text-area';
import { useTranslation } from '@hooks/index';

interface ReviewTypeDetailsProps {
    reviewTypeName?: string | null;
    reviewTypeDescription?: string | null;
    createdAudit?: string;
    updatedAudit?: string;
}

export const ReviewTypeDetails = ({
    reviewTypeName,
    reviewTypeDescription,
    createdAudit,
    updatedAudit,
}: ReviewTypeDetailsProps) => {
    const { t } = useTranslation('admin');

    return (
        <div className="k-d-flex k-flex-column k-bg-white k-p-3 k-overflow-y-auto k-gap-2" style={{ height: '98%' }}>
            <div className="k-d-flex k-gap-3 k-align-items-center">
                <div className="k-font-medium k-flex-shrink-0" style={{ color: '#3E536E', width: '97.8px' }}>
                    {t('smReviewPlans.grid.columns.reviewType')}
                </div>
                <div style={{ color: '#757575', wordBreak: 'break-word' }}>{reviewTypeName ?? 'N/A'}</div>
            </div>
            {createdAudit && (
                <div className="k-d-flex k-gap-3 k-align-items-center">
                    <div className="k-font-medium k-flex-shrink-0" style={{ color: '#3E536E', width: '97.8px' }}>
                        {t('smReviewPlans.grid.columns.createdBy')}
                    </div>
                    <div style={{ color: '#757575' }}>{createdAudit}</div>
                </div>
            )}
            {updatedAudit && (
                <div className="k-d-flex k-gap-3 k-align-items-center">
                    <div className="k-font-medium k-flex-shrink-0" style={{ color: '#3E536E', width: '97.8px' }}>
                        {t('smReviewPlans.grid.columns.updatedBy')}
                    </div>
                    <div style={{ color: '#757575' }}>{updatedAudit}</div>
                </div>
            )}
            <div className="k-d-flex k-flex-column k-flex-1 k-gap-2">
                <div className="k-font-medium" style={{ color: '#3E536E' }}>
                    {t('smReviewPlans.grid.columns.description')}
                </div>
                <TextArea
                    className={styles.textAreaOverrides}
                    data-testid="review-type-details-description"
                    readOnly
                    value={reviewTypeDescription ?? undefined}
                    style={{ height: '100%', minHeight: '150px', overflow: 'auto', resize: 'none' }}
                />
            </div>
        </div>
    );
};
